/**
 * Centralized React Query key definitions.
 * Use these constants everywhere instead of inline string arrays
 * to prevent typos and make invalidation refactors easy.
 */

import { SearchOptions } from '../constants/app';

export const queryKeys = {
  requestLabels: (requestTypeId: number) =>
    ['requestLabels', requestTypeId] as const,

  requestTypes: () => ['requestTypes'] as const,

  requests: (params: SearchOptions) => ['requests', params] as const,

  workflowLabels: (workflowType: string) =>
    ['workflowLabels', workflowType] as const,

  workflowTypes: () => ['workflowTypes'] as const,

  workflows: () => ['workflows'] as const,
};
